import { matchPropertyPath } from './object-path'
import projectType from '../project_types/editor.config'

export function getConfig(projectTypeCustomId) {
    return projectType[projectTypeCustomId.toLocaleUpperCase()]
}

export function getScreenGroup(projectTypeCustomId, filter = { screenTags: null, group: null }) {
    const config = getConfig(projectTypeCustomId)
    if (filter.screenTags) {
        return config.screens.groups.find(g => filter.screenTags.indexOf(g.tag) >= 0)
    }
    if (filter.group) {
        return config.screens.groups.find(g => g.group === filter.group)
    }
    return null
}

export function needShowScreenControl(projectTypeCustomId) {
    const config = getConfig(projectTypeCustomId)

    return config.screens.showScreenControl
}

/**
 * Получить описания контролов для свойства path
 *
 * @param {string} projectTypeCustomId например 'TRIVIA'
 * @param {string} path например 'router.screens.z6z9sh.backgroundColor'
 * @param {*} options
 */
export function getPropertyControlConfig(projectTypeCustomId, path, { screens, screenId, popupId }) {
    const config = getConfig(projectTypeCustomId)
    if (config && config.controls) {
        return config.controls.filter(desc => {
            if (typeof desc.what === 'string') {
                const screen = screens.filter(({ hashlistId }) => hashlistId === screenId)[0]

                if (!screen) return matchPropertyPath(path, desc.what)

                const components = (popupId && screen.popups && screen.popups[popupId]
                    ? screen.popups[popupId]
                    : screen
                ).components

                return matchPropertyPath(path, desc.what, components)
            } else if (typeof desc.what === 'function') {
                return desc.what({ path, screens, screenId })
            }
            throw new Error(`Invalid selector 'what' ${desc.what}`)
        })
    }
    return []
}
